import { useEffect, useRef, useState } from 'react'

// RAL-182: a loader that flashes on a warm cache feels slower than no loader at all, so the
// element must stay out of the DOM until the gate elapses — a setTimeout, not a motion delay.
// Once shown it holds a floor so it can't blink in and out on a request that lands just after.
export const LOADER_GATE_MS = 300
export const ROUTE_LOADER_GATE_MS = 150
const MIN_HOLD_MS = 500

export const useDelayedLoading = (isLoading: boolean, gateMs: number = LOADER_GATE_MS): boolean => {
  const [visible, setVisible] = useState(false)
  const shownAt = useRef(0)

  useEffect(() => {
    if (isLoading) {
      if (visible) return
      const gate = setTimeout(() => {
        shownAt.current = Date.now()
        setVisible(true)
      }, gateMs)
      return () => clearTimeout(gate)
    }

    if (!visible) return
    const remaining = MIN_HOLD_MS - (Date.now() - shownAt.current)
    if (remaining <= 0) {
      setVisible(false)
      return
    }
    const hold = setTimeout(() => setVisible(false), remaining)
    return () => clearTimeout(hold)
  }, [isLoading, gateMs, visible])

  return visible
}
